<template>
  <DisplayGridCards>
    <AccountButton
      v-if="!profile.isParent"
      theme="neutral"
      aspect="4-3"
      @click="handleShareSponsor"
    >
      <template #icon>
        <icon name="sponsor" size="4rem" :color="$colors.secondary" />
      </template>
      {{ $t('settings.sponsor') }}
    </AccountButton>

    <AccountButton
      v-if="!profile.isParent"
      theme="neutral"
      aspect="4-3"
      to="/famille"
    >
      <template #icon>
        <icon name="accountFamily" size="4rem" :color="$colors.secondary" />
      </template>
      {{ $t('settings.family') }}
    </AccountButton>

    <AccountButton theme="neutral" aspect="4-3" @click="handleClickParameters">
      <template #icon>
        <icon name="settings" size="4rem" :color="$colors.secondary" />
      </template>
      {{ $t('settings.preferences') }}
    </AccountButton>

    <AccountButton theme="neutral" aspect="4-3" to="/mes-statistiques">
      <template #icon>
        <icon name="statistics" size="4rem" :color="$colors.secondary" />
      </template>
      {{ $t('settings.stats') }}
    </AccountButton>

    <AccountButton theme="neutral" aspect="4-3" to="/mes-amis">
      <template #icon>
        <icon name="nomad:friends" size="4rem" :color="$colors.secondary" />
      </template>
      {{ $t('settings.friends') }}
    </AccountButton>

    <AccountButton
      v-if="!profile.isASubscriber"
      theme="neutral"
      aspect="4-3"
      :to="`${runtimeConfig.public.eva1Url}/premium`"
    >
      <template #icon>
        <GraphicMask
          src="/images/icons/nomad+.svg"
          :size="4"
          :color="$colors.secondary"
        />
      </template>
      {{ $t('settings.subscribe') }}
    </AccountButton>
  </DisplayGridCards>
</template>
<script setup lang="ts">
import DialogSettingsParameters from '~/components/dialog/settings/preferences/DialogSettingsPreferences.vue';

const runtimeConfig = useRuntimeConfig();

const profile = useProfileStore();

const dialog = useDialogStore();

const { handleShareSponsor } = useShareSponsor();

const { $colors } = useNuxtApp();

const handleClickParameters = () => {
  dialog.open(DialogSettingsParameters, {
    level: DialogLevel.Settings,
    position: 'center',
  });
};
</script>
